module.exports = __webpack_public_path__ + "static/media/SLB.83d1334c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/SLB.jpg
// module id = 5749
// module chunks = 0